<template>
<div class="chapter">
<div class="inner_page">
<div class="contents">
<a id="TOC1"><h1 class="contentsHead">Contents</h1>
</a><p class="contentsEntry" style="text-indent:0%;"><a id="TOC1"></a><span href="#/e9780545794695_title001#tp01" title="Link target outside of Sample">Title Page</span></p>
<p class="contentsEntry" style="text-indent:0%"><span href="#/e9780545794695_ded001" title="Link target outside of Sample">Dedication</span></p>
<p class="contentsEntry" style="text-indent:0%"><a href="#/e9780545794695_ch001">“It’s Always Us!”</a></p>
<p class="contentsEntry" style="text-indent:0%"><span href="#/e9780545794695_ch002" title="Link target outside of Sample">The Fish’s Decree</span></p>
<p class="contentsEntry" style="text-indent:0%"><span href="#/e9780545794695_ch003" title="Link target outside of Sample">The Cannon at Midnight</span></p>
<p class="contentsEntry" style="text-indent:0%"><span href="#/e9780545794695_ch004" title="Link target outside of Sample">Assignment: Obnoxious!</span></p>
<p class="contentsEntry" style="text-indent:0%"><span href="#/e9780545794695_ch005" title="Link target outside of Sample">You Keep <em class="italic">Ants</em>?</span></p>
<p class="contentsEntry" style="text-indent:0%"><span href="#/e9780545794695_ch006" title="Link target outside of Sample">Round Two</span></p>
<p class="contentsEntry" style="text-indent:0%"><span href="#/e9780545794695_ch007" title="Link target outside of Sample">Desperate Measures</span></p>
<p class="contentsEntry" style="text-indent:0%"><span href="#/e9780545794695_ch008" title="Link target outside of Sample">Raid!</span></p>
<p class="contentsEntry" style="text-indent:0%"><span href="#/e9780545794695_ch009" title="Link target outside of Sample"><em class="italic">Expelled?</em></span></p>
<p class="contentsEntry" style="text-indent:0%"><span href="#/e9780545794695_ch010" title="Link target outside of Sample">Breakfast at Scrimmage’s</span></p>
<p class="contentsEntry" style="text-indent:0%"><span href="#/e9780545794695_ch011" title="Link target outside of Sample">“Congratulations, Boys”</span></p>
<p class="contentsEntry" style="text-indent:0%"><span href="#/e9780545794695_ch012" title="Link target outside of Sample">Help!</span></p>
<p class="contentsEntry" style="text-indent:0%"><span href="#/e9780545794695_ch013" title="Link target outside of Sample">Scrimmage’s to the Rescue</span></p>
<p class="contentsEntry" style="text-indent:0%"><span href="#/e9780545794695_ch014" title="Link target outside of Sample">No End to Miracles!</span></p>
<p class="contentsEntry" style="text-indent:0%"><span href="#/e9780545794695_ata001" title="Link target outside of Sample">About the Author</span></p>
<p class="contentsEntry" style="text-indent:0%"><span href="#/e9780545794695_bm001" title="Link target outside of Sample">Q&amp;A with Gordon Korman</span></p>
<p class="contentsEntry" style="text-indent:0%"><span href="#/e9780545794695_fm001" title="Link target outside of Sample">Also Available</span></p>
<p class="contentsEntry" style="text-indent:0%"><span href="#/e9780545794695_copy001" title="Link target outside of Sample">Copyright</span></p>
</div>
</div>
</div>
</template>
<script>

export default {
  name: 'chapter',
  data() {
    return {}
    },
      components: {
    }
  }
</script>



// WEBPACK FOOTER //
// e9780545794695_toc001.vue?16b528f0